import React from 'react';
import compostableTag from 'src/assets/svg/order/compostable.svg';
import dairyFreeTag from 'src/assets/svg/order/dietary-dairy-free.svg';
import glutenFreeTag from 'src/assets/svg/order/dietary-gluten-free.svg';
import halalTag from 'src/assets/svg/order/dietary-halal.svg';
import kosherTag from 'src/assets/svg/order/dietary-kosher.svg';
import lowFodmapTag from 'src/assets/svg/order/dietary-low-fodmap.svg';
import organicTag from 'src/assets/svg/order/dietary-organic.svg';
import paleoTag from 'src/assets/svg/order/dietary-paleo.svg';
import veganTag from 'src/assets/svg/order/dietary-vegan.svg';
import vegetarianTag from 'src/assets/svg/order/dietary-vegetarian.svg';
import whole30Tag from 'src/assets/svg/order/dietary-whole30.svg';
import { DishFirstFoodItemFragment, FoodItemTagFieldsFragment, Packaging } from 'src/gqlReactTypings.generated.d';
import styled from 'styled-components';
import { DietaryTags } from 'web-common/src/shared/Enums';

export type DisplayedFoodItemTags = Partial<
  Pick<
    FoodItemTagFieldsFragment | DishFirstFoodItemFragment,
    | 'spiceLevel'
    | 'vegetarian'
    | 'vegan'
    | 'glutenFree'
    | 'dairyFree'
    | 'paleo'
    | 'lowFodmap'
    | 'whole30'
    | 'isHalal'
    | 'isOrganic'
    | 'packaging'
    | 'kosher'
  >
>;

export const dietaryTagToFoodItemField: Record<DietaryTags, (item: DisplayedFoodItemTags) => boolean> = {
  [DietaryTags.VEGETARIAN]: (item) => (item.vegetarian && !item.vegan) ?? false,
  [DietaryTags.VEGAN]: (item) => item.vegan ?? false,
  [DietaryTags.GLUTEN_FREE]: (item) => item.glutenFree ?? false,
  [DietaryTags.DAIRY_FREE]: (item) => (item.dairyFree && !item.vegan) ?? false,
  [DietaryTags.PALEO]: (item) => item.paleo ?? false,
  [DietaryTags.LOW_FODMAP]: (item) => item.lowFodmap ?? false,
  [DietaryTags.WHOLE30]: (item) => item.whole30 ?? false,
  [DietaryTags.HALAL]: (item) => item.isHalal ?? false,
  [DietaryTags.ORGANIC]: (item) => item.isOrganic ?? false,
  [DietaryTags.COMPOSTABLE]: (item) => item.packaging === Packaging.Compostable,
  [DietaryTags.KOSHER]: (item) => item.kosher ?? false,
};

export const dietaryTagToImgSrc: Record<DietaryTags, string> = {
  [DietaryTags.VEGETARIAN]: vegetarianTag,
  [DietaryTags.VEGAN]: veganTag,
  [DietaryTags.GLUTEN_FREE]: glutenFreeTag,
  [DietaryTags.DAIRY_FREE]: dairyFreeTag,
  [DietaryTags.PALEO]: paleoTag,
  [DietaryTags.LOW_FODMAP]: lowFodmapTag,
  [DietaryTags.WHOLE30]: whole30Tag,
  [DietaryTags.HALAL]: halalTag,
  [DietaryTags.ORGANIC]: organicTag,
  [DietaryTags.COMPOSTABLE]: compostableTag,
  [DietaryTags.KOSHER]: kosherTag,
};

interface IProps {
  dietaryTag: DietaryTags;
  styles?: React.CSSProperties;
  className?: string;
}

const Icon = styled.img`
  width: 24px;
`;

export const DietaryIconImg: React.FC<IProps> = ({ dietaryTag, styles, className }) => (
  <Icon
    className={className}
    src={dietaryTagToImgSrc[dietaryTag]}
    style={styles}
    title={`${dietaryTag} dish`}
    alt={dietaryTag}
  />
);
